import React from 'react';
import { I } from '../icons-ds';

export type TabBarProps = {
  active?: string;
  onNavigate: (target: string) => void;
  transparent?: boolean;
};

type Item = {
  id: string;
  icon: React.ReactNode;
  label: string;
};

export function TabBar({ active, onNavigate, transparent }: TabBarProps) {
  const items: Item[] = [
    { id: 'home', icon: <I.search size={22} />, label: 'Search' },
    { id: 'favorites', icon: <I.starFill size={22} />, label: 'Favorites' },
    { id: 'folders', icon: <I.folder size={22} />, label: 'Folders' },
    { id: 'glossary', icon: <I.bookmark size={22} />, label: 'Glossary' },
    { id: 'settings', icon: <I.user size={22} />, label: 'You' },
  ];

  return (
    <nav
      aria-label="Main navigation"
      className="dp-tabbar"
      style={{
        background: transparent ? 'transparent' : 'var(--bg-translucent)',
        backdropFilter: 'saturate(1.8) blur(20px)',
        WebkitBackdropFilter: 'saturate(1.8) blur(20px)',
        borderTop: '0.5px solid var(--line-divider)',
      }}
    >
      {items.map((it) => (
        <button
          key={it.id}
          className="dp-tabbar-item"
          aria-current={active === it.id ? 'page' : undefined}
          onClick={() => onNavigate(it.id)}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
            color: active === it.id ? 'var(--accent)' : 'var(--fg-tertiary)',
            fontSize: 10, fontWeight: 500, letterSpacing: 0.1,
            transition: 'color var(--dur-fast) var(--ease-out)',
            background: 'transparent', border: 0, cursor: 'pointer',
          }}
        >
          {it.icon}
          <span>{it.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default TabBar;
